import React, { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser'; // Make sure this is installed: npm install @emailjs/browser
import './Enquiry.css'; // We will update the CSS file next

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    destination: '', // Added this specific field for inquiries
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
        alert("Please fill in all required fields.");
        return;
    }

    if (!window.confirm('Are you sure you want to send this enquiry?')) {
        return;
    }

    setIsSubmitting(true);
    setStatusMessage('');

    // --- EMAILJS CONFIGURATION ---
    // You can use the SAME Service ID and Public Key as your Booking form.
    // However, I recommend creating a NEW Template for Inquiries so the email subject is different.
    const serviceID = 'service_w7bl9te'; 
    const templateID = 'template_1krw6cn'; // Create a new template for "Enquiries"
    const publicKey = 'Ryz61QN6Q-4t5i4r7';

    try {
      await emailjs.send(serviceID, templateID, formData, publicKey);
      
      setStatusMessage('Enquiry sent successfully! We will get back to you shortly.');
      setFormData({ name: '', email: '', destination: '', message: '' }); // Clear form
      alert('Enquiry sent successfully!'); // Keep the alert as requested
    } catch (error) {
      console.error('Failed to send enquiry:', error);
      setStatusMessage('Failed to send. Please try again later.');
      alert('Failed to send enquiry. Please check your connection.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="enquiry-container">
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Make an Enquiry
      </motion.h2>
      <p style={{marginBottom: '20px', color: '#666'}}>
        Have questions about a specific destination? Let us know!
      </p>

      <form onSubmit={handleSubmit} className="enquiry-form">
        <div>
          <input 
            type="text" 
            name="name" 
            placeholder="Your Name" 
            value={formData.name} 
            onChange={handleChange} 
            required
          />
        </div>
        <div>
          <input 
            type="email" 
            name="email" 
            placeholder="Your Email" 
            value={formData.email} 
            onChange={handleChange} 
            required
          />
        </div>
        <div>
          {/* New Field specifically for Places */}
          <input 
            type="text" 
            name="destination" 
            placeholder="Destination of Interest (Optional)" 
            value={formData.destination} 
            onChange={handleChange} 
          />
        </div>
        <div>
          <textarea 
            name="message" 
            placeholder="What would you like to know?" 
            value={formData.message} 
            onChange={handleChange} 
            required
          />
        </div>

        {statusMessage && <p className={`status-msg ${statusMessage.includes('Failed') ? 'error' : 'success'}`}>{statusMessage}</p>}

        <div className="enquiry-buttons">
          <motion.button
            type="submit"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Enquiry'}
          </motion.button>
          
          <a href="/brochure.pdf" download>
            <motion.button
              type="button"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              style={{ backgroundColor: '#2f4f4f' }} // Green for download
            >
              Download Brochure
            </motion.button>
          </a>
        </div>
      </form>
    </div>
  );
};

export default Enquiry;